<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <div @click="close()" class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <form
      @submit.prevent="update()"
      class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
    >
      <div class="mt-3 text-center sm:mt-0 sm:text-left">
        <h3 class="text-lg leading-6 text-gray-900">Kontingent bearbeiten</h3>
        <div class="mt-6 grid grid-cols-1 row-gap-6 sm:row-gap-0 col-gap-4 sm:grid-cols-6">
          <basic-input
            class="sm:col-span-3"
            v-model="input.count"
            :label="input.relative ? 'Kontingent verändern um' : 'Neues Kontingent'"
            type="number"
            :placeholder="input.relative ? 'Kontingent verändern um' : 'Neues Kontingent'"
            :error="errors['count']"
          />
          <div class="sm:col-span-3 text-left">
            <label class="block text-sm font-medium leading-5 text-gray-700">Aktuelle Daten</label>
            <div class="grid grid-cols-3 mt-1 text-sm">
              <div class="col-span-2">Kontingent:</div>
              <div>{{contingentProp.count}}</div>
              <div class="col-span-2">Verkauft:</div>
              <div>{{contingentProp.count - contingentProp.available}}</div>
              <div class="col-span-2">Im Warenkorb:</div>
              <div>{{contingentProp.reserved}}</div>
            </div>
          </div>

          <basic-checkbox
            class="sm:col-span-3 row-start-2 sm:row-start-auto"
            v-model="input.relative"
            label="Relativ verändern"
          />
        </div>
      </div>
      <div class="mt-5 sm:flex">
        <basic-button
          class="w-full sm:w-auto"
          button-class="w-full justify-center"
          type="submit"
          color="green"
          :disabled="loading"
          :loading="loading"
        >Verändern</basic-button>
        <basic-button
          class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-3 sm:w-auto"
          button-class="w-full justify-center"
          color="white"
          @click="close()"
        >Abbrechen</basic-button>
      </div>
    </form>
  </div>
</template>


<script>
import _cloneDeep from "lodash/cloneDeep";
import BasicCheckbox from "@/components/basic/Checkbox";

import contingentClient from "@/api/central/contingents";

export default {
  components: { BasicCheckbox },
  props: {
    contingentProp: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      input: { count: null, relative: false },
      contingent: this.contingentProp,
      loading: false,
      errors: {}
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    async update() {
      this.loading = true;
      this.errors = {};

      // Change contingent on server
      await contingentClient
        .update(this.contingent.id, this.input)
        .catch(error => {
          this.errors = error.response.data.errors;
          this.loading = false;

          throw error;
        });

      // Fire refresh for vuex
      this.$store.dispatch("editor/refresh");

      // Await updated contingent and update the cloned object for prices
      await contingentClient
        .show(this.contingent.id)
        .then(({ data }) => Object.assign(this.contingent, data.data));

      this.loading = false;

      this.$emit("close");
    }
  }
};
</script>